import { type CMSTradeRegion } from '~/networking/api/cms/responses/CMSRegion';
import { Heading, Text } from '~/vinovest-design-system/components';

interface RegionInfoProps {
    region: CMSTradeRegion;
}

export function RegionInfo({ region }: RegionInfoProps): JSX.Element {
    const { description, investing, latest, forward } = region;
    return (
        <>
            {description && (
                <>
                    <Heading level={'h2'} classnames={'py-6'}>
                        Region Summary
                    </Heading>
                    <Text classnames={'mb-6 leading-loose'}>{description}</Text>
                </>
            )}
            {investing && (
                <>
                    <Heading level={'h2'} classnames={'py-6'}>
                        Why We're Investing
                    </Heading>
                    <Text classnames={'mb-6 leading-loose'}>{investing}</Text>
                </>
            )}
            {latest && (
                <>
                    <Heading level={'h2'} classnames={'py-6'}>
                        What's the Latest
                    </Heading>
                    <Text classnames={'mb-6 leading-loose'}>{latest}</Text>
                </>
            )}
            {forward && (
                <>
                    <Heading level={'h2'} classnames={'py-6'}>
                        Looking Forward
                    </Heading>
                    <Text classnames={`xs:pb-[200px] mb-8 leading-loose`}>{forward}</Text>
                </>
            )}
        </>
    );
}
